import React from 'react';

import { Box } from '@twilio-paste/core/box';
import { Button } from '@twilio-paste/core/button';
import { Input } from '@twilio-paste/core/input';
import { Label } from '@twilio-paste/core/label';

interface Filter {
  label: string;
  name: string;
  optional: boolean;
}

interface SearchCustomersQueryFiltersProps {
  filters: Filter[];
  inputs: Record<string, string>;
  isFetching: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.FormEvent) => void;
}

export function SearchCustomersQueryFilters({
  filters,
  inputs,
  isFetching,
  handleChange,
  handleSubmit,
}: SearchCustomersQueryFiltersProps) {
  return (
    <Box as="form" onSubmit={handleSubmit} marginBottom="space40">
      {filters.map(field => (
        <Box key={field.name} marginBottom="space40">
          <Label htmlFor={field.name}>{field.label}</Label>
          <Input required={!field.optional} id={field.name} name={field.name} type="text" value={inputs[field.name] || ''} onChange={handleChange} />
        </Box>
      ))}
      <Button variant="primary" type="submit" loading={isFetching} disabled={isFetching}>
        Run Request
      </Button>
    </Box>
  );
}
